import { TriangleAlertIcon } from "lucide-react";
import tw from "twin.macro";

import {
  ApplicationErrorSeverityCodeEnum,
  Description,
  SeverityCodeEnum,
} from "@/api/events/modules/module-tracking";

const ErrorModuleItem = ({
  moduleAddress,
  severity,
  severityCode,
  label,
  doc,
}: {
  moduleAddress: string;
  severity: Description;
  severityCode: SeverityCodeEnum | ApplicationErrorSeverityCodeEnum;
  label: Description;
  doc: Description;
}) => {
  const language = "fr";

  const severityText = severity[language];
  const labelText = label[language];
  const docText = doc[language];

  return (
    <div
      tw="flex flex-col"
      css={[
        tw`rounded-xl bg-red-500`,
        severityCode === SeverityCodeEnum.CRITICAL && tw`bg-red-500`,
        severityCode === SeverityCodeEnum.WARNING && tw`bg-orange-500`,
      ]}
    >
      <div tw="flex items-center justify-between p-2">
        <p tw="text-sm font-medium flex items-center gap-2">
          <span>
            <TriangleAlertIcon
              tw="w-4 h-4"
              color={
                severityCode === SeverityCodeEnum.CRITICAL ? "red" : "orange"
              }
              fill="white"
            />
          </span>
          <span>{moduleAddress}</span>
        </p>
        <p
          css={[
            tw`text-white px-2 py-1 rounded-2xl text-xs`,
            severityCode === SeverityCodeEnum.CRITICAL && tw`bg-red-500`,
            severityCode === SeverityCodeEnum.WARNING && tw`bg-orange-500`,
          ]}
        >
          {severityText}
        </p>
      </div>
      <div tw="flex flex-col gap-1 bg-white shadow-sm border border-gray-200 p-2 rounded-bl-lg rounded-br-lg">
        <p tw="text-base font-medium">
          {severityCode === SeverityCodeEnum.CRITICAL
            ? "Erreur critique"
            : "Alerte"}
        </p>
        <p tw="text-sm font-light text-gray-500">{labelText}</p>
        <p tw="text-sm font-light text-gray-500">{docText}</p>
      </div>
    </div>
  );
};

export default ErrorModuleItem;
